/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskCmdbGlobalConfigureType from '@jira/spa-apps__servicedesk-cmdb-configure-v2/src/index.tsx';
import type { EntryPointProps } from 'react-relay';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbGlobalConfigure: LazyComponent<
	({ entryPoints }: EntryPointProps<{}, {}, {}, {}>) => React.JSX.Element
> = lazyForPaint<typeof ServicedeskCmdbGlobalConfigureType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-servicedesk-cmdb-global-configure", jiraSpaEntry: "async-servicedesk-servicedesk-cmdb-global-configure" */ '@jira/spa-apps__servicedesk-cmdb-configure-v2/src/index.tsx'
		),
);

const GlobalConfigure = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbGlobalConfigure}
		pageId="spa-apps/servicedesk/insight/cmdb-configure"
		shouldShowSpinner
	/>
);

export default GlobalConfigure;
